import React from 'react';

import { BootstrapConfig, bootstrapConfig } from '~src/config/bootstrap-config';

import { CountryStateContext } from '~src/main/context/country-state';
import { useGlobalStateQuery } from '~src/main/context/global-state-query';
import { GlobalStateContext } from '~src/main/context/global-state';
import {
  useCheckoutLocalizationQuery,
  useFaqLocalizationQuery,
} from '~src/main/context/localization-query';
import { LocalizationContext } from '~src/main/context/localization';
import { useCountryNamesLocalizationQuery } from '~src/main/country/country-localization';
import { useIpcStateSender } from '~src/main/utils/ipc-utils';

import { Widget } from '~src/main/widget/widget';

export type CountryConfig = Pick<BootstrapConfig, 'country'> &
  Partial<Pick<BootstrapConfig, 'currency'>>;

export const WidgetInit: React.FC = () => {
  const [countryConfig, setCountryConfig] = React.useState<CountryConfig>({
    country: bootstrapConfig.country,
    currency: bootstrapConfig.currency,
  });
  const globalQuery = useGlobalStateQuery(countryConfig);
  const checkoutLocalizationQuery = useCheckoutLocalizationQuery();
  const faqLocalizationQuery = useFaqLocalizationQuery();
  const countryNamesLocalizationQuery = useCountryNamesLocalizationQuery();

  useIpcStateSender('global-state', globalQuery.data);
  useIpcStateSender('checkout-localization', checkoutLocalizationQuery.data);
  useIpcStateSender('faq-localization', faqLocalizationQuery.data);
  useIpcStateSender('country-names-localization', countryNamesLocalizationQuery.data);

  if (
    !globalQuery.isSuccess ||
    checkoutLocalizationQuery.isLoading ||
    faqLocalizationQuery.isLoading ||
    countryNamesLocalizationQuery.isLoading
  ) {
    return null;
  }

  const combinedLocalization: Record<string, string> = {
    ...(checkoutLocalizationQuery.data ?? {}),
    ...(faqLocalizationQuery.data ?? {}),
    ...(countryNamesLocalizationQuery.data ?? {}),
  };

  return (
    <CountryStateContext.Provider
      value={{ country: countryConfig, updateCountry: setCountryConfig }}
    >
      <GlobalStateContext.Provider value={globalQuery.data}>
        <LocalizationContext.Provider value={combinedLocalization}>
          <Widget />
        </LocalizationContext.Provider>
      </GlobalStateContext.Provider>
    </CountryStateContext.Provider>
  );
};
